export const blockIconsNavigationClose = (
	<span className='material-symbols-outlined'>close</span>
);
